module.exports = __webpack_public_path__ + "static/media/2.07f2b060.JPG";